import * as React from "react";

import "./Icon.css";

const SvgNoteIcon = ({ width, height, ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    data-name="Layer 1"
    viewBox="0 0 47.96 47.96"
    width={width || undefined}
    height={height ? height : "auto"}
    fill="currentColor"
    {...props}
    className={`svg-icon shake-two-icon-target ${props.className || ""}`}
    style={{
      transformOrigin: "center",
      ...props.style,
      ...(width ? { width: width } : {}),
      ...(height ? { height: height } : {}),
    }}
  >
    <defs>
      <style>
        {
          ".Note_Icon_svg__cls-1{fill:none;stroke:currentColor;stroke-miterlimit:10;stroke-width:2px}.Note_Icon_svg__cls-2{fill:currentColor}"
        }
      </style>
    </defs>
    <g transform="translate(8,0)">
      <path d="M1 1h31.56v46H1z" className="Note_Icon_svg__cls-1" />
      <path d="M3.51 3.32h26.53v4.87H3.51z" className="Note_Icon_svg__cls-2" />
      <path d="M4.58 11.54h7.13v6.43H4.58z" className="Note_Icon_svg__cls-1" />
      <path
        d="M13.46 10.6H29.8v2.88H13.46zM13.46 15.89h13.67v2.99H13.46z"
        className="Note_Icon_svg__cls-2"
      />
      <path d="M4.58 22.76h7.13v6.43H4.58z" className="Note_Icon_svg__cls-1" />
      <path
        d="M13.56 21.82H29.9v2.87H13.56zM13.56 27.11h8.17v2.99h-8.17zM7.12 43.41h19.32v2.04H7.12z"
        className="Note_Icon_svg__cls-2"
      />{" "}
    </g>
  </svg>
);
export default SvgNoteIcon;
